import { render, staticRenderFns } from "./ManuscriptDeleteConfirm.vue?vue&type=template&id=59df7498&scoped=true&"
import script from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptDeleteConfirm.vue?vue&type=style&index=0&id=59df7498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59df7498",
  null
  
)

export default component.exports